<template>
  <div class="usr-applylist">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户中心</el-breadcrumb-item>
      <el-breadcrumb-item>数据申请列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <el-form-item  label="申请授权状态">
          <el-select  size="mini" v-model="searchParams.apptype" style="width:120px;" filterable placeholder="Core/Guest/ToO/Temp" clearable>
                  <el-option
                      v-for="item in applytype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item  label="申请类型">
          <el-select  size="mini" v-model="searchParams.includeproposals" style="width:100px;" filterable placeholder="申请数据类型" clearable>
                  <el-option
                      v-for="item in Includedatas"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label="$t('proposal.obs_id')">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 220px"
            v-model="searchParams.obs_id"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item> 
        <el-form-item :label="`${$t('proposal.condition.proposal')}:`">
          <el-autocomplete
            size="mini"
            placeholder=""
            style="width: 200px"
            v-model="searchParams.proposal"
            :fetch-suggestions="proquerySearch"
            :trigger-on-focus="false"
            clearable>
          </el-autocomplete>
        </el-form-item>    
        <el-form-item :label="`${$t('proposal.target')}:`">
          <el-input size="mini" style="width: 120px" v-model="searchParams.target" clearable></el-input>
        </el-form-item>    
        <el-form-item :label="`${$t('proposal.obs_mode')}:`">
          <el-input size="mini" style="width: 60px" v-model="searchParams.obs_mode" clearable=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="list"
        @sort-change="sortChange"
        style="width: 100%">
        <el-table-column
          prop="idai"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          v-if="false"
          prop="name"
          label="申请人姓名">
        </el-table-column>
        <el-table-column
          v-if="false"
          prop="useremail"
          label="申请人邮箱">
        </el-table-column>
        <el-table-column
          sortable="custom"
          :label="$t('UserVerify.Applicationtype')">
          <template slot-scope="{row}">
            <span :title="$t(`UserVerify.includeproposal.${row.includeproposal}`)">{{$t(`UserVerify.includeproposal.${row.includeproposal}`)}}</span>
          </template>>
        </el-table-column>
        <el-table-column
          v-if="false"
          prop="applycop"
          label="申请人机构">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="apply_date"
          label="申请日期">
        </el-table-column>
        <el-table-column
          prop="data_id"
          label="文件ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="obs_id"
          label="观测号">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="target"
          label="观测目标">
        </el-table-column>
        <el-table-column
          sortable="custom"
          width="75"
          prop="obs_mode"
          label="观测模式">
        </el-table-column>
        <el-table-column
          sortable="custom"
          prop="proposal"
          label="观测提案">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="数据用途"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="auth_code"
          label="授权码"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="authed_date"
          label="授权日期">
        </el-table-column>
        <el-table-column
          v-if="false"
          prop="sys_validity"
          width="55"
          label="系统有效期">
        </el-table-column>
        <el-table-column
          prop="end_date"
          label="失效日期">
        </el-table-column>
        <el-table-column
          width="75"
          prop="auth_states"
          label="授权状态">
        </el-table-column>
        <el-table-column
          prop="state"
          width="300"
          label="申请状态">
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>    
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {ApplyTypeEn,ApplyTypeZh,Includedata} from '../common';
import { mapState } from 'vuex';
export default {
  name: 'applylist',
  components: {

  },
  data() {
    return {
      searchParams: {
        proposal:'',
        includeproposals:'all',
        obs_id:'',
        target:'',
        obs_mode:'',
        apptype:'all',
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderDirection: null,
      orderProp: '',
      Includedatas:Includedata,
      restaurants:[],
      prorestaurants:[],
    };
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
    applytype(){
      if (this.language === 'en') {
        return ApplyTypeEn;
      } else {
        return ApplyTypeZh;
      }
    },
  },

  created() {
    this.getobslistdata();
    this.getprolistdata();
    this.getData();
  },

  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchParams,
      };
      if (this.orderDirection && this.orderProp) {
        params.orderDirection = this.orderDirection;
        params.orderProp = this.orderProp;
      }
      axios.post('/iapi/getUsrappData', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }else if(res.data.errcode === 1){
          this.$message.error('数据不存在');
        }
      });
    },
    sortChange(param) {
      this.orderDirection = param.order;
      this.orderProp = param.prop;
      this.currentPage = 1;
      this.getData();
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    proquerySearch(queryString, cb) {
      let prorestaurants = this.prorestaurants;
      let results = queryString ? prorestaurants.filter(this.procreateFilter(queryString)) : prorestaurants;
      cb(results);
    },
    procreateFilter(queryString) {
      return (prorestaurants) => {
        return (prorestaurants.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    getobslistdata(){
      axios.post('/iapi/getobslist').then((res) => {
        if (res.data.errcode === 0) {
          this.restaurants = res.data.data;
        }
      });
    },
    getprolistdata(){
      axios.post('/iapi/proposallist').then((res) => {
        if (res.data.errcode === 0) {
          this.prorestaurants = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.usr-applylist {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 10px;
    margin-bottom: 10px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>